'use strict';

var React = require('react');

/**
 * A hook used to track the focus state of an input element.
 * @see InternalTextInput for usage
 */ const useInputFocus = (onBlur)=>{
    const [isFocused, setIsFocused] = React.useState(false);
    const [isDirty, setIsDirty] = React.useState(false);
    const [isKeyboardFocused, setIsKeyboardFocused] = React.useState(false);
    const textInputRef = React.useRef(null);
    const selectInputRef = React.useRef(null);
    const textAreaInputRef = React.useRef(null);
    const handleBlur = (e)=>{
        onBlur?.(e);
        setIsFocused(false);
        setIsKeyboardFocused(false);
        setIsDirty(true);
    };
    const lastInteractionWasKeyboard = React.useRef(false);
    React.useEffect(()=>{
        const handleKeyDown = (e)=>{
            if (e.key === "Tab") {
                lastInteractionWasKeyboard.current = true;
            }
        };
        const handleMouseDown = ()=>{
            lastInteractionWasKeyboard.current = false;
        };
        window.addEventListener("keydown", handleKeyDown);
        window.addEventListener("mousedown", handleMouseDown);
        return ()=>{
            window.removeEventListener("keydown", handleKeyDown);
            window.removeEventListener("mousedown", handleMouseDown);
        };
    }, []);
    const handleFocus = ()=>{
        setIsFocused(true);
        setIsKeyboardFocused(lastInteractionWasKeyboard.current);
    };
    return {
        isFocused,
        isDirty,
        isKeyboardFocused,
        handleFocus,
        handleBlur,
        textInputRef,
        selectInputRef,
        textAreaInputRef
    };
};

exports.useInputFocus = useInputFocus;
//# sourceMappingURL=useInputFocus.cjs.map
